import { put, takeEvery } from "redux-saga/effects"
import { IResponse, Route } from "../../types/global/types"
import { updateToken } from "../../utils/updateToken"
import { pointsAPI } from "../api/api"
import { generalActions } from "../store/reducers/generalReducer"
import {
  actionTypes,
} from "../store/reducers/pointsReducer"


function* deletePoint(action: {
  type: typeof actionTypes.DELETE_POINT_TRIGGER;
  payload: { id: number; routeId: number };
}) {
  const { id } = action.payload;
  try {
    const response: IResponse<Route> = yield pointsAPI.deletePoint(id)
    if (response.status === 200) {
      updateToken()
      // yield put(
      //   routesTriggerActions.getRouteTriggerAC({
      //     id: Number(routeId),
      //     address: true,
      //     household: true,
      //   })
      // );
      yield put(
        generalActions.successAC({ message: "Deleted", type: "success" })
      )
    }
  } catch (error: any) {
    yield put(
      generalActions.errorAC({
        message: error.response?.data?.message || "An error occurred",
        type: "error",
      })
    )
  }
}

export function* pointsWatcher() {
  yield takeEvery(actionTypes.DELETE_POINT_TRIGGER, deletePoint)
}
